import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TransactionVerificationComponent } from './transaction-verification.component';

const routes: Routes = [{ path: '', component: TransactionVerificationComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionVerficationRoutingModule { }


